import { render, staticRenderFns } from "./OkOnly.vue?vue&type=template&id=1cd19583&scoped=true"
import script from "./OkOnly.vue?vue&type=script&lang=js"
export * from "./OkOnly.vue?vue&type=script&lang=js"
import style0 from "./OkOnly.vue?vue&type=style&index=0&id=1cd19583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd19583",
  null
  
)

export default component.exports